import { enumToNameWithDefault, rawValueToEnumWithDefault } from '@ps-smart-cp/ppfw-client';
import { offBalanceFaControlClassConfig } from './OffBalanceFaControlClass.name';

/** オフバランスの資産管理区分のENUM */
enum OffBalanceFaControlClass {
  /** 通常資産   */
  normalAsset = '1',
  /** 簿外資産 */
  unaccountedAsset = '4',
}

const OffBalanceFaControlClassMap = new Map([
  ['1', OffBalanceFaControlClass.normalAsset],
  ['4', OffBalanceFaControlClass.unaccountedAsset],
]);

const rawValueToOffBalanceFaControlClass = rawValueToEnumWithDefault(
  OffBalanceFaControlClassMap,
  OffBalanceFaControlClass.normalAsset,
);

const offBalanceFaControlClassToDisplay = enumToNameWithDefault(
  OffBalanceFaControlClass,
  offBalanceFaControlClassConfig,
);

const offBalanceFaControlClassToDisplayWithPrefix = enumToNameWithDefault(
  OffBalanceFaControlClass,
  offBalanceFaControlClassConfig,
  true,
);

export {
  OffBalanceFaControlClass,
  offBalanceFaControlClassToDisplay,
  offBalanceFaControlClassToDisplayWithPrefix,
  rawValueToOffBalanceFaControlClass,
};
